<backstage-alert level="warning">
  <h5 i18n>Verify Your Email</h5>
  <p>
    @if (emailVerifiedUntil) {
      <ng-container i18n>Your email address verification expired on</ng-container>
      {{ emailVerifiedUntil | date: 'mediumDate' }}.
    } @else {
      <ng-container i18n>Your email address is currently unverified.</ng-container>
    }
    <ng-container i18n>Access to downloads and other services is restricted.
      Please verify your email by requesting a new verification token and following the link in the email we
      send you.
    </ng-container>
  </p>
  <p class="m-0">
    <backstage-button (click)="sendVerificationEmail()">
      <i class="bi-check-circle-fill me-1"></i> <ng-container i18n>Verify now</ng-container>
    </backstage-button>
    <backstage-button href="/account/profile" variant="link">
      <ng-container i18n>Go to account settings</ng-container>
    </backstage-button>
  </p>
</backstage-alert>
